module.exports=function(scope){ return `${scope.message}`};